import React from 'react';
import { Upload } from 'lucide-react';

interface PressMaterialsBrowserProps {
  userRole: string;
}

export function PressMaterialsBrowser({ userRole }: PressMaterialsBrowserProps) {
  const canEdit = userRole === 'admin' || userRole === 'pr';
  const PRESS_MATERIALS_FOLDER_ID = '154LFDrFKeDybI1doAYzHkKWRXlyT0gTA';

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="section-header">Press Materials</h2>
        {canEdit && (
          <button
            onClick={() => window.open(`https://drive.google.com/drive/folders/${PRESS_MATERIALS_FOLDER_ID}`, '_blank')}
            className="btn-primary text-sm"
            title="Open Google Drive to upload files"
          >
            <Upload size={16} className="mr-2" />
            Upload Files
          </button>
        )}
      </div>

      {/* Embedded Google Drive Folder */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <iframe
          src={`https://drive.google.com/embeddedfolderview?id=${PRESS_MATERIALS_FOLDER_ID}#grid`}
          width="100%"
          height="600"
          frameBorder="0"
          title="Press Materials"
          className="w-full"
        />
      </div>

      {/* Instructions */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="text-sm font-medium text-blue-900 mb-2">How to use Press Materials:</h3>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• Browse files and folders using the interface above</li>
          <li>• Click files to preview or download them</li>
          <li>• Use the search box in the Drive interface to find specific files</li>
          {canEdit && (
            <li>• Click "Upload Files" to add new press materials to this folder</li>
          )}
          <li>• Files uploaded to the Google Drive folder appear here automatically</li>
        </ul>
      </div>
    </div>
  );
}